/* eslint-disable no-shadow, camelcase */
import { WatermarkPosition, WatermarkType } from ".";

export enum EventStatus {
  Preparing = "PREPARING",
  BeforeStart = "BEFORE_START",
  Processing = "PROCESSING",
  Canceling = "CANCELING",
  Canceled = "CANCELED",
  ServerOpen = "SERVER_OPEN",
  Live = "LIVE",
  Encoding = "ENCODING",
  ReadyForVOD = "READY_FOR_VOD",
  Vod = "VOD",
  Ended = "ENDED",
  Archiving = "ARCHIVING",
  Archived = "ARCHIVED",
}

export enum EventType {
  Private = "PRIVATE",
  Public = "PUBLIC",
}

export enum EventMode {
  Landscape = "LANDSCAPE",
  Portrait = "PORTRAIT",
}

export enum Resolution {
  FourK = "4K",
  FullHD = "FHD",
  HD = "HD",
}

export enum EventPlan {
  Customized = "CUSTOMIZED",
  Massive = "MASSIVE",
  Medium = "MEDIUM",
  Small = "SMALL",
}

export enum ActivityMode {
  LiveMode = "LIVE_MODE",
  PlaybackMode = "PLAYBACK_MODE",
}

export enum VodType {
  LiveEncoding = "LIVE_ENCODING",
  VodReplacement = "VOD_REPLACEMENT",
}

export enum DisplayMode {
  DarkMode = "DARK_MODE",
  LightMode = "LIGHT_MODE",
}

interface EventVideo {
  id: string;
  mode: string;
  url: string;
  uploaded_at: number;
}

export interface RtmpUrl {
  main: string;
  backup: string;
}

export interface ViewInfo {
  channel_id: number;
  name: string;
  rtmp_url: RtmpUrl;
}

type GeoRestriction = "HK" | "JP" | "PH" | "KR" | "SG" | "TW";

interface Watermark {
  type: WatermarkType;
  position: WatermarkPosition;
  image_url?: string;
}

export interface Event {
  id: string;
  customer_event_id: string;
  type: EventType;
  mode: EventMode;
  title: string;
  estimated_people: number;
  resolution: Resolution;
  plan: EventPlan;
  status: EventStatus;
  advanced_monitoring: boolean; // Does this live event require KKS operators' monitoring
  enable_chatroom: boolean; // Does this live event's chatroom display on the player
  cover: string; // The cover image url
  device_limit: number; // Device limit of the member per live event
  rtmp_url: RtmpUrl;
  geo_restrictions: GeoRestriction[] | null; // Geo restrictions
  operator_arranged: boolean; // Does this live event's operator arrangement is ready
  enable_drm: boolean; // Does this live event turn on the DRM protection
  report_generated: boolean;
  public_token: string; // If event type is public
  schedule_started_at: number; // Schedule start time
  schedule_ended_at: number; // Schedule end time
  catchup_started_at: number;
  vod_ended_at: number; // VOD end time
  vod_started_at: number; // VOD end time
  segment_started_at: number; // Segment real start time
  segment_ended_at?: number; // Segment real end time
  started_at: number; // Real start time
  ended_at: number; // Real end time
  created_at: number;
  updated_at: number;
  vod_to_live: boolean;
  video?: EventVideo;
  forced_close?: boolean;
  watermark?: Watermark;
  enable_domain_restriction: boolean;
  restriction_domains: string[];
  activity_mode?: ActivityMode;
  loom_api_key?: string;
  loom_job_id?: string;
  enable_ultra_low_latency: boolean;
  vod_type: VodType;
  vod_previewable: boolean;
  chatroom_setting?: {
    display_mode: DisplayMode;
  };
  enable_vod_chatroom?: boolean;
  vod_chatroom_setting?: {
    display_mode: DisplayMode;
  };
  enable_start_over?: boolean;
  start_over_custom_start_time?: number;
}

export enum LiveFileStatus {
  Created = "created",
  Transcoding = "transcoding",
  TranscodeSucceeded = "transcode_succeeded",
  TranscodeFailed = "transcode_failed",
  Transferring = "transferring",
  TransferSucceeded = "transfer_succeeded",
  TransferFailed = "transfer_failed",
}

interface StatusHistory {
  status: LiveFileStatus;
  created_at: number;
}

export interface LiveFile {
  id: number; // integer
  name: string;
  cloud_storage_id: string;
  customer_file_id: string;
  start_time: number;
  end_time: number;
  auto_transfer: boolean;
  customer_file_name: string;
  customer_thumbnail_name: string;
}

export interface LiveFileList extends LiveFile {
  status_history: StatusHistory[];
  status: LiveFileStatus;
  is_archived: boolean;
}
